import {createContext, Dispatch, SetStateAction, useContext} from 'react';

export interface RedeemStepsContextProps {
	code: string;
	setNormalizedCode: Dispatch<SetStateAction<string>>;
}

export const RedeemStepsContext = createContext<RedeemStepsContextProps>({
	code: '',
	setNormalizedCode: () => {}
});

export function useRedeemStepsContext() {
	return useContext<RedeemStepsContextProps>(RedeemStepsContext);
}
